import React, { useRef, useState, useEffect } from 'react';
import { useProSidebar } from 'react-pro-sidebar';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import Icon from '../Icon/Icon';
import logo from '../../assets/img/finfactor_svg_logo.svg';
import { useDispatch } from 'react-redux';
import { authActions } from '../../store/reducers/authSlice';
import styles from './Header.module.css';
import consentStyles from '../../pages/Consent Request/css/Consent.module.css';
import { useNavigate } from 'react-router-dom';
import { Password } from 'primereact/password';
import { useFormik } from 'formik';
import Error from '../Error/Error';
import { Button } from 'primereact/button';
import { modifyUserPassword } from '../../utils/common.utils';
import {editPasswordSchema} from '../../schemas/index'

const Header = () => {
	const menu = useRef(null);
	const dispatch = useDispatch();
	const { collapseSidebar } = useProSidebar();
	const navigate = useNavigate();
	const [currentDate, setCurrentDate] = useState(new Date());
	const [showModal, setShowModal] = useState(false);

	const userProfileMenuItems = [
		{
			label: 'Change Password',
			icon: (
				<Icon icon="password" className={styles['header-menu-logout__icon']} />
			),
			command: () => {
				setShowModal(true);
			},
		},
		{
			label: 'Logout',
			icon: (
				<Icon icon="logout" className={styles['header-menu-logout__icon']} />
			),
			command: () => {
				dispatch(authActions.logout());
				navigate('/');
			},
		},
	];

	useEffect(() => {
		const timer = setInterval(() => {
			setCurrentDate(new Date());
		}, 1000);

		return () => {
			clearInterval(timer);
		};
	}, []);

	const options = {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
	};
	const formattedDate = currentDate
		.toLocaleString('en-US', options)
		.replace(',', '')
		.replace('at', '');

	const configLogo = JSON.parse(sessionStorage.getItem('config'))?.['logo_uri'];

	const initialValues = {
		password: '',
		newPassword: '',
		confirmPassword: '',
	};

	const { values, touched, errors, handleChange, handleBlur, handleSubmit } =
		useFormik({
			initialValues: initialValues,
			validationSchema: editPasswordSchema,
			onSubmit: (formValues, action) => {
				try {
					const inputData = {
						password: formValues.password,
						newPassword: formValues.newPassword,
						confirmPassword: formValues.confirmPassword,
					};

					modifyUserPassword(inputData, setShowModal)
						.then(() => {
							dispatch(authActions.logout());
							navigate('/');
						})
						.catch((err) => {
							action.resetForm();
						});
				} catch (error) {
					console.error('Error changing user password:', error);
				}
			},
		});
	return (
		<>
			<header className={styles.header}>
				<div className={styles['header-image__container']}>
					<img
						src={configLogo || logo}
						alt="logo"
						height="50"
						className={styles['header-image']}
					/>
				</div>
				<div
					className={styles['header-sidebar-icon__container']}
					onClick={() => collapseSidebar()}
				>
					<Icon icon="format_align_justify" />
				</div>
				<div className={styles['header-content']}>
					<div>Welcome back user!</div>
					<div className={styles['header-content__datetime']}>
						<div>{formattedDate}</div>
					</div>
				</div>
				<div className={styles['header-user-icon__container']}>
					<span
						className={`material-symbols-rounded ${styles['header-user-icon']}`}
						onClick={(e) => menu.current.toggle(e)}
					>
						person
					</span>
					<Menu
						model={userProfileMenuItems}
						popup
						ref={menu}
						className={styles['header-menu']}
					/>
				</div>
			</header>
			<Dialog
				onHide={() => setShowModal(false)}
				visible={showModal}
				header="Change Password"
			>
				<div>
					<form className={styles.form} onSubmit={handleSubmit}>
						<div className={consentStyles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="password" className={styles['input-label']}>
									Enter Password:
								</label>
							</div>
						</div>
						<div className="p-inputgroup">
							<Icon icon="lock_reset" className="p-inputgroup-addon" />
							<Password
								toggleMask
								feedback={false}
								className={`${
									touched.password && errors.password ? 'p-invalid' : ''
								} styles.input`}
								id="password"
								name="password"
								placeholder="Enter your password"
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
							/>
						</div>
						{touched.password && errors.password ? (
							<Error>{errors.password}</Error>
						) : null}
						<div className={consentStyles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="newPassword" className={styles['input-label']}>
									New password:
								</label>
							</div>
						</div>
						<div className="p-inputgroup">
							<Icon icon="lock" className="p-inputgroup-addon" />
							<Password
								toggleMask
								feedback={false}
								className={`${
									touched.newPassword && errors.newPassword ? 'p-invalid' : ''
								} styles.input`}
								id="newPassword"
								name="newPassword"
								placeholder="New password"
								value={values.newPassword}
								onChange={handleChange}
								onBlur={handleBlur}
							/>
						</div>
						{touched.newPassword && errors.newPassword ? (
							<Error>{errors.newPassword}</Error>
						) : null}
						<div className={consentStyles['input__container']}>
							<div className={styles['label__container']}>
								<label
									htmlFor="confirmPassword"
									className={styles['input-label']}
								>
									Confirm password:
								</label>
							</div>
						</div>
						<div className="p-inputgroup">
							<Icon icon="lock" className="p-inputgroup-addon" />
							<Password
								toggleMask
								feedback={false}
								className={`${
									touched.confirmPassword && errors.confirmPassword
										? 'p-invalid'
										: ''
								} styles.input`}
								id="confirmPassword"
								name="confirmPassword"
								placeholder="Confirm password"
								value={values.confirmPassword}
								onChange={handleChange}
								onBlur={handleBlur}
							/>
						</div>
						{touched.confirmPassword && errors.confirmPassword ? (
							<Error>{errors.confirmPassword}</Error>
						) : null}
						<div className={styles['button__container']}>
							<Button>Change Password</Button>
						</div>
					</form>
				</div>
			</Dialog>
		</>
	);
};

export default Header;
